exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(true);
// Module
exports.push([module.id, ".C8zyM0Cslts-FgVYLL5NQ {\n  width: 25vw;\n}\n\n  @media (min-width: 1024px) {.C8zyM0Cslts-FgVYLL5NQ {\n    width: 19vw\n}\n  }\n", "",{"version":3,"sources":["AboutMePics.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AAKb;;EAHE,4BAHF;IAII;AAEJ;EADE","file":"AboutMePics.css","sourcesContent":[".img {\n  width: 25vw;\n\n  @media (min-width: 1024px) {\n    width: 19vw;\n  }\n}\n"]}]);
// Exports
exports.locals = {
	"img": "C8zyM0Cslts-FgVYLL5NQ"
};